module.exports = __webpack_public_path__ + "img/CDCBC8_444342_696765_81807E-256px.7d5f8c09.png";